export default __webpack_public_path__ + "static/media/ErrorIcon@2x.ad509523.png";